"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistogramComponent = void 0;
var d3 = require("d3");
var React = require("react");
var react_1 = require("react");
var styles = require("../styles/PredictionModelResultsViz");
var colors = require("../util/colors");
var sizes = require("../util/sizes");
var utils_1 = require("../util/utils");
var HistogramComponent = function (props) {
    var title = props.title, description = props.description, hideBorder = props.hideBorder, data = props.data, numBins = props.numBins, yAxisLabel = props.yAxisLabel, xAxisLabel = props.xAxisLabel, color = props.color;
    var chartRef = react_1.useRef(null);
    var height = sizes.heightRegular;
    var width = sizes.widthRegular;
    var margin = sizes.chartMargins;
    var chartHeight = height - margin.top - margin.bottom;
    var chartWidth = width - margin.left - margin.right;
    var xAxisTranslate = height - margin.bottom;
    var yAxisTranslate = margin.left;
    // Histogram bin calculations
    var histogram = d3.histogram().thresholds(numBins);
    var bins = histogram(data);
    //  Create scales
    var yScaleMaxValue = d3.max(bins, function (d) { return d.length; });
    var xScaleMaxValue = d3.max(bins, function (d) { return d.x1; });
    var yScale = d3
        .scaleLinear()
        .domain([0, yScaleMaxValue])
        .range([height - margin.bottom, margin.top]);
    var xScale = d3
        .scaleLinear()
        .range([margin.left, width - margin.right])
        .domain([0, xScaleMaxValue]);
    var drawAxes = react_1.useCallback(function () {
        var svg = d3.select(chartRef.current);
        var yAxis = utils_1.getLinearAxis(yScale, utils_1.AxisPosition.Left);
        utils_1.formatAxis(yAxis, 5, 0, 7, utils_1.TickFormat.formatK);
        utils_1.drawAxis(svg, yAxis, yAxisTranslate, 0);
        var xAxis = utils_1.getLinearAxis(xScale, utils_1.AxisPosition.Bottom);
        utils_1.formatAxis(xAxis, bins.length, sizes.defaultTickSize, sizes.defaultTickPadding, utils_1.TickFormat.formatK);
        utils_1.drawAxis(svg, xAxis, 0, xAxisTranslate);
        var ticks = d3.selectAll('.tick text');
        ticks.each(function (_, i) {
            // Show less ticks based on number of bins
            if (i % (numBins / 5) !== 0)
                d3.select(this).remove();
        });
        // draw background lines
        var backgroundAxis = utils_1.getLinearAxis(yScale, utils_1.AxisPosition.Left);
        utils_1.formatAxis(backgroundAxis, 5, -chartWidth, sizes.defaultTickPadding, utils_1.TickFormat.hideNumbers);
        utils_1.drawAxisGridLines(svg, backgroundAxis, yAxisTranslate, 0);
    }, [bins.length, chartWidth, numBins, xAxisTranslate, xScale, yAxisTranslate, yScale]);
    var drawBars = react_1.useCallback(function () {
        d3.select(chartRef.current)
            .selectAll('rect')
            .data(bins)
            .enter()
            .append('rect')
            .attr('x', 1)
            .attr('transform', function (d) {
            return 'translate(' + (xScale(d.x0 || 0) || 0).toString() + ',' + (margin.top + (yScale(d.length) || 0)).toString() + ')';
        })
            .attr('width', function (d) {
            return (xScale(d.x1 || 0) || 0) - (xScale(d.x0 || 0) || 0) - 1;
        })
            .attr('height', function (d) { return chartHeight - (yScale(d.length) || 0); })
            .style('fill', color || colors.defaultBlue);
    }, [bins, chartHeight, color, margin.top, xScale, yScale]);
    react_1.useEffect(function () {
        // Create svg and set dimensions
        d3.select(chartRef.current).selectAll('*').remove(); // To avoid stacking svg every re-render
        var svg = d3.select(chartRef.current).attr('height', height).attr('width', width);
        drawAxes();
        drawBars();
        utils_1.drawAxisLabel(svg, xAxisLabel || '', chartWidth / 2 + margin.left, sizes.chartFontSize);
        utils_1.drawAxisLabel(svg, yAxisLabel || '', sizes.chartFontSize, chartHeight / 2 + margin.top, true);
    }, [chartHeight, chartWidth, drawAxes, drawBars, height, margin, width, xAxisLabel, yAxisLabel]);
    return (React.createElement("div", { className: hideBorder ? styles.cardContainer : styles.cardContainer + ' ' + styles.cardBorderShadow },
        React.createElement("div", { className: hideBorder ? styles.card : styles.cardBorder + ' ' + styles.card },
            title && React.createElement("label", { className: styles.cardTitle }, title),
            description && React.createElement("label", { className: styles.cardDescription }, description),
            React.createElement("svg", { ref: chartRef }))));
};
exports.HistogramComponent = HistogramComponent;
//# sourceMappingURL=HistogramComponent.js.map